import { Table, Tbody, Tr, Box } from "@chakra-ui/react";
import { CustomTextComponent, FaqItem } from "@components/index";
import { TABLE_ITEM_LAYOUT_TYPE } from "@root/constants/common";
import React from "react";
import { Paginate } from "../pagination";
import {
  CustomTableContainer,
  StyledChatTableContainer,
  StyledPaginationContainer,
} from "./styled";
import { ColumnFlex } from "../dashboard/chat/style";
import { CustomText } from "../common/components";


export const TableComponent: React.FC<ITableComponent> = ({
  tableData,
  itemType,
  showPagination = true,
  pageCount,
  page,
  pageSize,
  handlePageChange,
  parentSelectedChat,
  onClick,
  onRemove,
  onExpand,
  onSeletionChange,
}) => {
  const removePagination =
    itemType === TABLE_ITEM_LAYOUT_TYPE.PRIVACY_POLICY ||
    itemType === TABLE_ITEM_LAYOUT_TYPE.TERMS_CONDITIONS;

  const renderTableItem = (data: any, index: any) => {
    if (itemType === TABLE_ITEM_LAYOUT_TYPE.FAQ) {
      return <FaqItem data={data} index={index} onExpand={onExpand} />;
    }

    if (
      itemType === TABLE_ITEM_LAYOUT_TYPE.PRIVACY_POLICY ||
      itemType === TABLE_ITEM_LAYOUT_TYPE.TERMS_CONDITIONS
    ) {
      return (
        <Box backgroundColor={"theme.brown.100"}>
          <CustomTextComponent
            title={data?.title}
            description={data?.description}
            lastUpdate={data?.lastUpdate}
            tableContent={data?.tableContent}
            titleSize="18px"
            titleWeight={500}
            descriptionSize="14px"
            descriptionWeight={400}
          />
        </Box>
      );
    }

    return null;
  };

  const onPageChange = (newPage: number) => {
    if (typeof onPageChange === "function") {
      handlePageChange(newPage);
    }
  };

  const screensWithNoBorder = [
    TABLE_ITEM_LAYOUT_TYPE.CHAT_HISTORY,
    TABLE_ITEM_LAYOUT_TYPE.FAQ,
    TABLE_ITEM_LAYOUT_TYPE.PAYMENT_METHODS,
  ];

  return (
    <StyledChatTableContainer>
      <CustomTableContainer
        border={screensWithNoBorder.includes(itemType) ? "none" : "1px solid"}
        borderColor={removePagination ? "transparent" : "gray.100"}
        overflow={"scroll"}
      >
        <Table
          overflowY={"scroll"}
          overflowX={"hidden"}
          whiteSpace="wrap"
          variant="unstyled"
        >
          <Tbody>
            {tableData &&
              tableData?.length &&
              tableData?.map((data: any, index: any) => (
                <Tr key={index} whiteSpace="wrap" minHeight={"89px"}>
                  <ColumnFlex>
                    {itemType === TABLE_ITEM_LAYOUT_TYPE.CHAT_HISTORY && (
                      <CustomText
                        fontSize={"16px"}
                        marginLeft={"25px"}
                        marginTop={"15px"}
                        text={`${data?.date} 일`}
                      />
                    )}
                    {renderTableItem(data, index)}
                  </ColumnFlex>
                </Tr>
              ))}
          </Tbody>
        </Table>
      </CustomTableContainer>
      {showPagination && !removePagination ? (
        <StyledPaginationContainer position={"fixed"} bottom={-5} right={0}>
          <Paginate
            page={page}
            count={pageCount}
            pageSize={pageSize}
            onPageChange={onPageChange}
            margin={1}
            variant="ghost"
            isRtl={false}
          />
        </StyledPaginationContainer>
      ) : null}
    </StyledChatTableContainer>
  );
};
